var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.23975C4.85937 1.23975 1.5 4.43714 1.5 8.37516C1.5 12.9064 6.5 20.0871 8.33594 22.5674C8.41215 22.6721 8.51203 22.7572 8.62744 22.816C8.74284 22.8747 8.8705 22.9053 9 22.9053C9.1295 22.9053 9.25716 22.8747 9.37256 22.816C9.48797 22.7572 9.58785 22.6721 9.66406 22.5674C11.5 20.0882 16.5 12.9101 16.5 8.37516C16.5 4.43714 13.1406 1.23975 9 1.23975Z",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.2417C10.3807 11.2417 11.5 10.1224 11.5 8.7417C11.5 7.36099 10.3807 6.2417 9 6.2417C7.61929 6.2417 6.5 7.36099 6.5 8.7417C6.5 10.1224 7.61929 11.2417 9 11.2417Z",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationimg);
export default __webpack_public_path__ + "static/media/Locationimg.c3be8eb71b0dd62a99bc6e98aa5ee0a3.svg";
export { ForwardRef as ReactComponent };